module.exports = __webpack_public_path__ + "static/media/sg.5e652763.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sg.svg
// module id = 764
// module chunks = 0